import React, { useEffect, useRef } from "react";
import { goToNextStep, goBackToPrevStep, restart } from "context/AppContext/actions";
import { ButtonContinue, ButtonGoBack, ButtonHome, ButtonRestart } from "components/Button";
import { useAppContext } from "context/AppContext/AppContext";
import { useThemeContext } from "context/ThemeContext";
import StepQuestionWrap from "components/styled/StepQuestionWrap.styled";
import StepQuestionText from "components/styled/StepQuestionText.styled";
import ScrollDownText from "components/ScrollDownText";
import StepLearnMoreTop from "components/styled/StepLearnMoreTop.styled";
import LearnMoreItem from "./LearnMoreItem";
import { motion } from "framer-motion";

const StepLearnMore = () => {
  const { theme } = useThemeContext();
  const { state, dispatch } = useAppContext();
  const { currentStep, scenario } = state;
  const nextStepId = currentStep.nextStepId;
  const learnmoreRef = useRef(null)

  const handleGoBack = () => {
    if (currentStep.id === scenario.firstStepId) {
      dispatch(restart());
    } else {
      dispatch(goBackToPrevStep());
    }
  };

  const  handleArrowDownClick = () => {
    learnmoreRef.current.scrollIntoView({behavior: "smooth"})
  }

  useEffect(() => {
    window.scroll({left: 0, top: 0});
  }, [currentStep]);

  const BackgroundImage = currentStep.backgroundImage;

  return (
    <div className="step-learnmore">
      <StepLearnMoreTop className="step-learnmore__top">
        <StepQuestionWrap>
          {currentStep.backgroundImage && <div className="background-image">{<BackgroundImage />}</div>}
          <motion.div className="content" initial={{opacity: 0, y:40}} animate={{opacity: 1, y:0}} transition={{duration: 0.3}}>
            <StepQuestionText className="question-text" dangerouslySetInnerHTML={{ __html: currentStep.text }}></StepQuestionText>
            {currentStep.scrollText && <ScrollDownText handleArrowDownClick={handleArrowDownClick} text={currentStep.scrollText} />}
            <div className="buttons">
              {nextStepId && <ButtonGoBack onClick={handleGoBack} />}
              {nextStepId && <ButtonContinue disabled={!nextStepId} onClick={() => dispatch(goToNextStep(nextStepId))} />}
              {!nextStepId && <ButtonHome />}
              {!nextStepId && <ButtonRestart onClick={() => dispatch(restart())} />}
            </div>
          </motion.div>
        </StepQuestionWrap>
      </StepLearnMoreTop>

      <div className="step-learnmore__bottom" ref={learnmoreRef}>
        {currentStep.learnmore && (
          <LearnMoreItem
            title={currentStep.learnmore.title}
            content={currentStep.learnmore.content}
            backgroundColor={theme.colors.primary}
            linkUnderlineColor={scenario.linkUnderlineColor}
          />
        )}
        {!nextStepId && (
          <LearnMoreItem
            title={scenario.finalStepLearnmore.title}
            content={scenario.finalStepLearnmore.content}
            textColor={theme.colors.textDark}
            backgroundColor={theme.colors.backgroundDark}
            linkUnderlineColor={theme.colors.orange}
          />
        )}
        {!nextStepId && <LearnMoreItem title={scenario.finalStepThankYou.title} content={scenario.finalStepThankYou.content} backgroundColor={theme.colors.orange} />}
      </div>
    </div>
  );
};

export default StepLearnMore;
